import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceTypeOPEEnum} from "./DeviceTypeOPEEnum";
import {ProtocolTypeEnum} from "../../enums/registry/ProtocolTypeEnum";

class DeviceTypeDTO {
  id!: number;
  modelName!: string;
  partNumber?: string;
  modbusWritePauseMillis?: number;
  manufacturer?: ManufacturerDTO;
  protocolType!: ProtocolTypeEnum;
  metricGroups!: MetricGroupDTO[];
}

class ManufacturerDTO {
  id!: number;
  name!: string;
}

export class MetricGroupDTO {
  id!: number;
  name?: string;
  transportConfiguration: any;
  metrics!: MetricDTO[];
  isWritableOnEdge!: boolean;
}

export class DataUnitDTO {
  id!: number;
  name!: string;
}

export class MetricDTO {
  id!: number;
  name!: string;
  dataUnit!: DataUnitDTO;
  byteOrder!: string;
  divider!: number;
  bitPosition?: number;
  decimalDigits?: number;
  isWritableOnEdge!: boolean;
  selected: boolean = true;
  transportConfiguration: any;
}

class O {
  deviceType!: DeviceTypeDTO;
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}

export class GetDeviceTypeCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DeviceTypeOPEEnum.GetDeviceType);
    this.i = new I();
    this.o = new O();
  }
}
